import { CreateProductReviewModalData } from '@zyro-inc/site-modules/types';
import { SiteBlock } from '@hostinger/builder-schema-validator/schema/schemaTypes';
import { ref } from 'vue';
import { MEDIA_MOBILE_BREAKPOINT } from '@zyro-inc/site-modules/constants/siteModulesConstants';

const createProductReviewData = ref<CreateProductReviewModalData | undefined>();
const openEcommerceModalName = ref<string>('');
const productPreviewData = ref<SiteBlock | undefined>();
const quickPreviewProductId = ref<string>('');

export const useEcommerceModal = () => {
	const openEcommerceModal = (name: string) => {
		const params = new URLSearchParams(window.location.search);

		if (!params.get('open-modal')) {
			params.set('open-modal', name);
			window.history.pushState({}, '', `?${params.toString()}`);
		}

		openEcommerceModalName.value = name;

		if (window.innerWidth < MEDIA_MOBILE_BREAKPOINT) {
			document.body.style.overflow = 'hidden';
		}
	};

	const closeEcommerceModal = () => {
		if (window.innerWidth < MEDIA_MOBILE_BREAKPOINT) {
			document.body.style.overflow = 'auto';
		}

		openEcommerceModalName.value = '';
	};

	const setProductPreviewData = (blockData: SiteBlock, productId: string) => {
		productPreviewData.value = blockData;
		quickPreviewProductId.value = productId;
	};

	const setCreateProductReviewData = (reviewData: CreateProductReviewModalData | undefined) => {
		createProductReviewData.value = reviewData;
	};

	return {
		openEcommerceModal,
		closeEcommerceModal,
		createProductReviewData,
		openEcommerceModalName,
		productPreviewData,
		quickPreviewProductId,
		setCreateProductReviewData,
		setProductPreviewData,
	};
};
